import React from "react";

interface ErrorViewProps {
  children: React.ReactNode;
}

export const ErrorView: React.FC<ErrorViewProps> = ({ children }) => {
  return (
    <div
      style={{
        display: "flex",
        height: "100%",
        overflow: "none",
        textAlign: "center",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {children}
    </div>
  );
};
